// extracted by mini-css-extract-plugin
export var active = "_38-7";
export var container = "_38-0";
export var evenWidth = "_38-4";
export var large = "_38-5";
export var outlet = "_38-8";
export var slide = "_38-2";
export var small = "_38-6";
export var tab = "_38-3";
export var tabs = "_38-1";